module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/HighGrowthCulture_InlineImage.8311a9e6.jpg";